import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 'lex-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
    },
});

export const isEnvDetailsLoading = atom({
    key: 'lex-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 'lex-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'lex-sspOrder',
    default: {
        // Application Section
        applicationName: null,
        appShortName: null,
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,

        // Resource Section
        awsAccount: null,
        botName: null,
        botDescription: null,
        botPrefix: null,
        creationMethod: 'Create Blank Bot',
        locale: null,
        voiceId: null,
        sessionTimeout: null,
        ischildDirected: null,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'lex-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'lex-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'lex-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 'lex-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'lex-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'lex-isAppShortNameExist',
    default: false,
});
